import { useTranslation } from "react-i18next";
import React from "react";
import { BaseSelectFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";

const EmailVerifiedFilter = ({ label = "l.searchFilter.emailVerified", ...others }: FilterLabelProps) => {
  const { t } = useTranslation();

  const options = [
    { value: "true", text: t("l.yes") },
    { value: "false", text: t("l.no") },
  ];

  return (
    <BaseSelectFieldFilter
      label={label}
      emptyOptionLabel={"Всички"}
      fieldName={"emailVerified"}
      options={options}
      addEmptyOption
      {...others}
    />
  );
};

export default EmailVerifiedFilter;
